var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Helmet = require('react-helmet');
var Loader = require('react-loader');
var Link = require('react-router').Link;
var Video = require( './layout/video.jsx' );
var ContentMarkDown = require( './layout/contentMarkDown.jsx' );
var BackButton = require('../../components/backButton.jsx');

var BodyPart = createReactClass({
	mixins: [PureRenderMixin],

    componentDidMount: function() {
        this.props.fetchBodyPartIfNeeded(this.props.params.name);
    },

    hasDataLoaded: function(){
        return !!(this.props.bodyPart.items && this.props.bodyPart.items.friendlyUrl === this.props.params.name);
    },

    getContent: function(){
        var bodyPart = this.props.bodyPart.items;

        var children = [
            <Helmet
                title={(bodyPart.meta && bodyPart.meta.title) || bodyPart.title}
                meta={[{
                    name: 'description',
                    content: (bodyPart.meta && bodyPart.meta.description) || bodyPart.description
                }]}
                key={0} />,
			<div className="content-header-wrapper" key={'content-header-wrapper'}>
				<div className="row content-header">
					<div className="small-12 medium-3 column back show-for-medium">
						<Link to="/education" onClick={this.props.setActiveEducationToggle.bind(null, 'BODYPARTS')}><span className="ion-ios-arrow-thin-left"></span> back to All Systems</Link>
					</div>
					<div className="small-12 medium-6 column title">
						<h1>{bodyPart.title}</h1>
					</div>
					<div className="small-12 medium-3 column"></div>
				</div>
			</div>,
			<BackButton key="back-button" />,
            <div id="hero-container" key={1}>
                <div id="hero">
                    <div className="row">
                        <div className="medium-7 small-12 column medium-centered">
                            <Video gender={this.props.auth.user.sex} video={bodyPart.video} />
                        </div>
                    </div>
                </div>
            </div>,
            <section id="information" key={2}>
                <div className="row">
                    <div className="topic small-12 column">
                        <h1>About {bodyPart.title}</h1>
                        <ContentMarkDown payload={bodyPart.education} />
                    </div>
                </div>
            </section>
        ];

        var content = (
            <Loader loaded={this.hasDataLoaded()}>
                {children}
            </Loader>
        );

        if(this.hasDataLoaded()){
            content = children;
        }

        return content;
    },

    render: function () {
        return (
            <div className="content">
                {this.getContent()}
            </div>
        );
    }
});

module.exports = BodyPart;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/bodypart.jsx